export function getColoredSvg(color) {
	return getEncodedSvg(color)
}

export function getEncodedSvg(color) {
	const svgWithFill = getSvgWithFill(color)
	const encodedSvg = encodeURIComponent(svgWithFill)
	return `data:image/svg+xml;charset=UTF-8,${encodedSvg}`
}

function getSvgWithFill(color) {
	return `
		<svg id="Warstwa_1" data-name="Warstwa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
		  <defs>
			<style>
			  .cls-1 {
				fill: none;
			  }
		
			  .cls-1, .cls-2 {
				stroke-width: 0;
			  }
		
			  .cls-2 {
				fill: ${color};
			  }
			</style>
		  </defs>
		  <polygon class="cls-2" points="62.5 37.5 62.5 0 37.5 0 37.5 37.5 0 37.5 0 62.5 37.5 62.5 37.5 100 62.5 100 62.5 62.5 87.5 62.5 100 62.5 100 37.5 62.5 37.5"/>
		</svg>
`;
}